<template>
  <b-container fluid>
    <!-- v-if="showSearch" -->
    <b-input-group
      description="You can use * and ? as wildcards"
      class="mt-3"
    >
      <b-form-input
        placeholder="Search documents"
        @keyup="debounceSearch"
        v-model="docsSearch"
      ></b-form-input>
      <b-input-group-append>
        <b-btn variant="secondary" @click="closeSearch">
          <i class="fa fa-eraser"/>
          Clear search
        </b-btn>
      </b-input-group-append>
    </b-input-group>

    <b-row>
      <b-col>
        <b-table
          :items="documents"
          :fields="enabledFields"
          :per-page="perPage"
          small
          class="doc-table table-hover small"
          
        >
          
          
          <template v-slot:head(actions)>
            <!-- <b-btn variant="primary" size="md" class="mb-1 mr-1" @click="showSearch = !showSearch">
              <i class="fa fa-search" />
            </b-btn> -->
            <b-dropdown
              variant="outline-secondary"
              size="md"
              class="mb-2"
              no-caret
              dropright
            >
              <template slot="button-content"
                ><i class="fa fa-ellipsis-v mx-1"
              /></template>

              <b-dropdown-form>
                <b-form-group label="Show columns">
                  <b-form-checkbox v-model="fieldOptions.pubdate" class="mb-1"
                    >Date</b-form-checkbox
                  >
                  <b-form-checkbox v-model="fieldOptions.author" class="mb-1"
                    >Author</b-form-checkbox
                  >
                  <b-form-checkbox v-model="fieldOptions.title" class="mb-1"
                    >Title</b-form-checkbox
                  >
                  <b-form-checkbox v-model="fieldOptions.citations" class="mb-1"
                    >CT</b-form-checkbox
                  >
                  <b-form-checkbox
                    v-model="fieldOptions.familycitations"
                    class="mb-1"
                    >FC</b-form-checkbox
                  >
                </b-form-group>
              </b-dropdown-form>
            </b-dropdown>
          </template>
          <!--
          <template v-slot:cell(pubdate)="data">
            <div>
              {{ data.item.pubdate }}
            </div>
          </template>
          -->
          <template v-slot:cell(author)="data">
            <div>
              {{ data.item.author }}
            </div>
          </template>
          <template v-slot:cell(applicant)="data">
            <div>
              {{ data.item.author }}
            </div>
          </template>
          <template v-slot:cell(title)="data">
            <div>
              <b-link
                class="text-dark fix-overflow"
                @click="viewDocument(data.item.webkey)"
              >
                {{ data.item.title }}
              </b-link>
            </div>
          </template>
          <template v-slot:cell(actions)="data">
            <div class="actions">
              <b-btn
                v-if="isFavorite(data.item.webkey)"
                variant="link-dark"
                size="sm"
                class="py-0 px-1"
                @click="unfavoriteDocument(data.item.webkey)"
              >
                <i class="fa fa-star" />
              </b-btn>
              <b-btn
                v-else
                variant="link-dark"
                size="sm"
                class="py-0 px-1"
                @click="favoriteDocument(data.item.webkey)"
              >
                <i class="far fa-star" />
              </b-btn>
              <b-btn
                variant="link-dark"
                size="sm"
                class="py-0 px-1"
                @click="viewDocument(data.item.webkey)"
              >
                <i class="fa fa-eye" />
              </b-btn>
              <b-btn
                variant="link-dark"
                size="sm"
                class="py-0 px-1"
                :href="typeof data.item.url === 'object' ? '' : data.item.url"
                target="_blank"
              >
                <i class="fa fa-external-link-alt" />
              </b-btn>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row class="doctable-pagination">
      <b-col class="d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          align="center"
        >
        </b-pagination>
        <b-dropdown
          text="Jump to page"
          variant="outline-secondary"
          size="sm"
          class="d-block ml-1"
          toggle-class="jump-to-page"
        >
          <b-dropdown-form @submit.prevent="jumpToPage">
            <b-form-group class="mb-0 text-center" label="Jump to page">
              <b-form-input
                v-model.number="jumpToPageInput"
                :placeholder="`1 – ${totalPages}`"
                class="text-center"
              >
              </b-form-input>
            </b-form-group>
            <b-btn type="submit" block variant="primary" size="sm" class="mt-2"
              >Jump</b-btn
            >
          </b-dropdown-form>
        </b-dropdown>
      </b-col>
      <b-col cols="2" class="position-absolute right-0">
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          size="sm"
          class="per-page"
        ></b-form-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/eventBus";

export default {
  name: "DocumentsTable",
  data() {
    return {
      fields: [
        {
          key: "pubdate",
          label: "Date",
          sortable: true,
          thClass: "w-10",
        },
        {
          key: "startdate",
          label: "Date",
          sortable: true,
          thClass: "w-10",
        },
        {
          key: "author",
          label: "Author",
          sortable: true,
          thClass: "w-10",
          tdClass: "fix-overflow",
        },
        {
          key: "applicant",
          label: "Applicant",
          sortable: true,
          thClass: "w-10",
          tdClass: "fix-overflow",
        },
        {
          key: "acronym",
          label: "Acronym",
          sortable: true,
          thClass: "w-10",
          tdClass: "fix-overflow",
        },
        {
          key: "title",
          label: "Title",
          sortable: true,
          thClass: "w-60",
          tdClass: "fix-overflow",
        },
        {
          key: "citations",
          label: "CT",
          sortable: true,
          thClass: "w-5 text-right",
          tdClass: "text-right",
        },
        {
          key: "familycitations",
          label: "FC",
          sortable: true,
          thClass: "w-5 text-right",
          tdClass: "text-right",
        },
        {
          key: "score",
          label: "Score",
          sortable: true,
          thClass: "w-5 text-right",
          tdClass: "text-right",
        },
        {
          key: "comment",
          label: "Comments",
          sortable: true,
          thClass: "w-5 text-right",
          tdClass: "text-right",
        },
        {
          key: "totalcost",
          label: "Total Cost",
          sortable: true,
          thClass: "w-5 text-right",
          tdClass: "text-right",
        },
        {
          key: "actions",
          label: "",
          sortable: false,
          thClass: "w-10 th-actions text-right",
          tdClass: "text-right",
        },
      ],
      fieldOptions: {
        pubdate: ['cordis'].includes(this.poolDbType())? false:true,
        applicant: ['google_patent','derwent'].includes(this.poolDbType())? true:false,
        author: ['cordis','derwent','google_patent'].includes(this.poolDbType())? false:true,
        startdate: ['cordis'].includes(this.poolDbType())? true:false,
        acronym: ['cordis'].includes(this.poolDbType())? true:false,
        title: true,
        citations: ['reddit','cordis'].includes(this.poolDbType())? false:true,
        familycitations: ['reddit','cordis'].includes(this.poolDbType())? false:true,
        score: ['reddit'].includes(this.poolDbType())? true:false,
        comment: ['reddit'].includes(this.poolDbType())? true:false,
        totalcost: ['cordis'].includes(this.poolDbType())? true:false
      },
      sortOn: "pubdate",
      sortAsc: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [
        { value: 10, text: "10 per page" },
        { value: 15, text: "15 per page" },
        { value: 30, text: "30 per page" },
        { value: 100, text: "100 per page" },
        { value: 500, text: "500 per page" },
        { value: 1000, text: "1000 per page" },
        { value: 2000, text: "2000 per page" }
      ],
      jumpToPageInput: null,
      filter: null,
      docsSearch: ""
      //showSearch: false,
    };
  },
  computed: {
    ...mapState({
      apiId: (state) => state.api.apiId,
      documents: (state) => state.document.documents,
      documentsCount: (state) => state.document.documentsCount,
      documentsPage: (state) => state.document.documentsPage,
      favorites: (state) => state.favorite.favorites,
    }),
    totalPages() {
      return Math.floor(
        this.documentsCount / this.perPage +
          (this.documentsCount % this.perPage) >
          0
          ? 1
          : 0
      );
    },
    totalRows() {
      return (
        Math.floor(this.documentsCount / this.perPage) * this.perPage +
        (this.documentsCount % this.perPage)
      );
    },
    enabledFields() {
      let enabledFields = [];
      _.each(this.fieldOptions, (v, k) => {
        if (v === true) {
          enabledFields.push(this.fields.find((f) => f.key === k));
        }
      });
      enabledFields.push(this.fields.find((f) => f.key === "actions"));
      return enabledFields;
    },
  },
  watch: {
    documentsPage(value) {
      //this.currentPage = value;
      localStorage.setItem("explore-documents-page", value);
    },
    perPage(value) {
      localStorage.setItem("explore-documents-per-page", value);
      this.loadDocumentsPage(this.currentPage);
    },
    currentPage(old,value) {
      console.log(old,value);
      if(parseInt(old) !== parseInt(value)){
        this.loadDocumentsPage(parseInt(old));
      }
    },
  },
  mounted() {
    let localStoragePerPage = localStorage.getItem(
      "explore-documents-per-page"
    );
    if (localStoragePerPage) {
      this.perPage = localStoragePerPage;
    }
    //this.perPageOptions.push({ value: this.documentsCount, text: "All" }); 
    EventBus.$on("loadFreshDocs", () => (this.currentPage = 1));
  },
  beforeDestroy() {
    EventBus.$off("loadFreshDocs");
  },
  methods: {
    ...mapActions(["loadDocuments", "saveFavorite", "deleteFavorite"]),
    isFavorite(webkey) {
      return (
        this.favorites &&
        this.favorites.length &&
        this.favorites.find((f) => f === webkey)
      );
    },
    poolDbType() {
      let DbType = localStorage.getItem("currentDbType")
      return DbType;
    },
    favoriteDocument(webkey) {
      this.saveFavorite({ webkey: webkey });
    },
    unfavoriteDocument(webkey) {
      this.deleteFavorite({ webkey: webkey });
    },
    viewDocument(webkey) {
      EventBus.$emit("viewDocument", webkey);
    },
    loadDocumentsPage(page) {
      this.loadDocuments({
        which: "global",
        page: page,
        pageSize: this.perPage,
        sortOn: this.sortOn,
        sortAsc: this.sortAsc,
        search: this.filter,
      });
      //this.currentPage = page;
    },
    debounceSearch: _.debounce(function (e) {
      this.filter = e.target.value.trim();
      this.loadDocumentsPage(1);
    }, 400),
    closeSearch() {
      // this.showSearch = false;
      this.filter = null;
      this.loadDocumentsPage(1);
      this.docsSearch = "";
    },
    sortingChanged(e) {
      if (this.sortOn === e.sortBy) {
        this.sortAsc = !e.sortDesc;
      } else {
        this.sortOn = e.sortBy;
        this.sortAsc = true;
      }
      //this.loadDocumentsPage(1);
    },
    jumpToPage() {
      if (
        isNaN(this.jumpToPageInput) ||
        this.jumpToPageInput > this.totalPages
      ) {
        return false;
      }

      this.loadDocumentsPage(this.jumpToPageInput);
      this.jumpToPageInput = null;
    },
  },
};
</script>
